import { MAX_REVIEW_STARS } from '../constants/reviews';
import { normalizeLineBreaks } from '../utils/normalizeLineBreaks';

const writeReviewModalDefault = (
  review,
  productId?: string,
  isMultiPackage = false
) => {
  const version = review.productMetadata?.upm?.packageVersion || '';

  const productMetadata = {
    upm: {
      packageVersion: version,
    },
  };

  return {
    productId: productId || '',
    title: '',
    imageUrl: '',
    version,
    ownedDate: '',
    isMultiPackage,
    data: {
      id: review.id,
      rating: review.rating ?? 0,
      title: review.title ?? '',
      body: normalizeLineBreaks(review.body ?? ''),
      productMetadata,
      lastUpdatedAt: review.updatedAt,
    },
  };
};

export const productReviewsDataMapper = (
  review,
  options?: {
    includeWriteReviewModal?: boolean;
    productId?: string;
    isMultiPackage?: boolean;
    canSubmitReview?: boolean;
  }
) => {
  const baseURL =
    process.env.NEXT_PUBLIC_SITE_URL || 'https://assetstore.unity.com';
  const mappedVersion = review.productMetadata?.upm?.packageVersion || '';

  return {
    id: review.id,
    reviewerInfo: {
      username: review.userProfile?.username ?? '',
      link: `${baseURL}/users/${review.userProfile?.id || ''}`,
      avatarUrl: review.userProfile?.image || '',
    },
    reviewDetails: {
      id: review.id,
      canSubmitReview: options?.canSubmitReview ?? false,
      stars: {
        value: review.rating ?? 0,
        max: MAX_REVIEW_STARS,
      },
      review: normalizeLineBreaks(review.body ?? ''),
      gifted: false,
      version: mappedVersion,
      title: review.title ?? '',
      publishedDate: review.createdAt,
      editedDate:
        review.updatedAt !== review.createdAt ? review.updatedAt : undefined,
      canReportReview: review.permissions?.canReportReview ?? false,
      canEdit: review.permissions?.canEdit ?? false,
      canDelete: review.permissions?.canDelete ?? false,
      canReply: false,
      canHelpfulVotes: review.permissions?.canMarkHelpful ?? false,
      reply: review.reply
        ? {
            id: review.reply.id,
            body: normalizeLineBreaks(review.reply.body),
            publishedDate: review.reply.createdAt,
            editedDate:
              review.reply.updatedAt !== review.reply.createdAt
                ? review.reply.updatedAt
                : undefined,
            helpfulVotes: 0,
            canHelpfulVotes: false,
            canEdit: false,
            canDelete: false,
          }
        : undefined,
      isMultiPackage: options?.isMultiPackage ?? false,
      writeReviewModal: writeReviewModalDefault(
        review,
        options?.productId,
        options?.isMultiPackage
      ),
    },
    ...(options?.includeWriteReviewModal && {
      writeReviewModal: writeReviewModalDefault(
        review,
        options?.productId,
        options?.isMultiPackage
      ),
    }),
  };
};
